import React, {useState} from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import {withStyles} from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { useHistory } from "react-router-dom";
import Gmail from "../../../../Images/gmail.png";
import outlook from "../../../../Images/outlook.png";


const useStyles = makeStyles((theme) => ({
    formWrapper: {
        background: "#fff",
        width: "400px",
        padding: theme.spacing(3),
    },
    title: {
        textTransform: "capitalize",
    },
    dialog_title: {
        "& h6": {
            fontWeight: "700"
        }
    }
}));

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const {children, classes, onClose, ...other} = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton
                    aria-label="close"
                    className={classes.closeButton}
                    onClick={onClose}
                >
                    <CloseIcon/>
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});


const ManageAccount = (props) => {
    const {open, onCloseAssignmentModal,} = props;
    const classes = useStyles();
 
    const [popupValue, setPopupValue] = useState('');
    let history = useHistory();
  


    const handleChange = (event) => {
        window.open(event,'_blank')
    };
    return (
        <>
            <Dialog maxWidth={"sm"} fullWidth={true} style={{height: '70%'}} open={open}
                    onClose={onCloseAssignmentModal}
                    aria-labelledby="base-station-manage">
                <DialogTitle id="customized-dialog-title" className={classes.dialog_title}>
                </DialogTitle>

                <DialogContent style={{margin: '0px auto'}}>
                <RadioGroup row aria-label="position" name="rate_type"  value={popupValue} onChange={(e)=>handleChange(e.target.value)}>
            
        <FormControlLabel
          value="https://accounts.google.com/signin/v2/identifier?continue=https%3A%2F%2Fmail.google.com%2Fmail%2F&service=mail&sacu=1&rip=1&flowName=GlifWebSignIn&flowEntry=ServiceLogin"
          control={<Radio color="primary" ></Radio>}
          // label="Email"
          label={
            <React.Fragment>
                <img src={Gmail} alt="gmail" className="profile-img" width="40px" height="auto" style={{ marginRight: "5px" }} />
              
            </React.Fragment>
        }
          labelPlacement="end"
        >
          <img alt="gmail" src={Gmail} />
          </FormControlLabel>
        <FormControlLabel
          value='https://outlook.live.com/'
          control={<Radio color="primary" />}
          label={
            <React.Fragment>
                <img src={outlook} alt="outlook" className="profile-img" width="40px" height="auto" style={{ marginRight: "5px" }} />
              
            </React.Fragment>
        }
          labelPlacement="end"
        />
        </RadioGroup>
                </DialogContent>

             
            </Dialog>
        </>
    )
}

export default ManageAccount
